export default __webpack_public_path__ + "static/media/S-016.25c6b16d.png";